import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'newsletter_subscribers',
            name: 'newsletterSubscriber',
            class: 'Modules\\Newsletter\\Entities\\NewsletterSubscriber'
        }
    }
}